import { ListItem } from '../models/list-item';

export function getItemById(list: ListItem[], id: string = ''): string {
  if (!id) return '';
  return list.find((item) => item.id === id)?.name || '';
}
